import crudFactory from "../crudFactory.ts";

const MODEL = "visibilities/lookup?archived=true";

const COMMON_CRUD_APIs = crudFactory(MODEL);

export default { ...COMMON_CRUD_APIs };
